import { ChainId, testnetAddresses } from '@endure/chains';

import type { Token } from 'types';
import type { Address } from 'viem';

export const WSTAO_WRAPPER_ADDRESSES: Partial<Record<ChainId, Address>> = {
  [ChainId.BITTENSOR_TESTNET]: testnetAddresses.wsTAO,
};

export const WALPHA_WRAPPER_TOKENS: Partial<Record<ChainId, readonly Token[]>> = {
  [ChainId.BITTENSOR_TESTNET]: [
    {
      chainId: ChainId.BITTENSOR_TESTNET,
      address: testnetAddresses.wAlpha288V2,
      decimals: 18,
      iconSrc: '',
      symbol: 'wAL-288',
    },
    {
      chainId: ChainId.BITTENSOR_TESTNET,
      address: testnetAddresses.wAlpha333V2,
      decimals: 18,
      iconSrc: '',
      symbol: 'wAL-333',
    },
    {
      chainId: ChainId.BITTENSOR_TESTNET,
      address: testnetAddresses.wAlpha418V2,
      decimals: 18,
      iconSrc: '',
      symbol: 'wAL-418',
    },
  ],
};
